<script setup lang="js">
import { computed } from 'vue';
import { useNodeStore } from '@/stores/node.store';
import { useProjectStore } from '@/stores/project.store';
import { useRouteParams } from '@vueuse/router';
import ModalTemplateCenter from '@/components/modals/ModalTemplateCenter.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';

const emit = defineEmits(['save']);

const projectId = useRouteParams('projectId');
const bpId = useRouteParams('bpId');

const { closeModal } = useModal();
const nodeStore = useNodeStore();
const { nodeRefData, deleteNodeRefRequest } = storeToRefs(nodeStore);
const projectStore = useProjectStore();

const locale = computed(() => projectStore.project.default_locale);
const sourceNodeTitle = computed(() => nodeRefData.value.sourceNode?.current?.node?.title[locale.value]);
const targetNodeTitle = computed(() => nodeRefData.value.targetNode?.current?.node?.title[locale.value]);

function deleteLink() {
  const bpNodeId = nodeRefData.value.sourceNode.id;
  const childBpNodeId = nodeRefData.value.targetNode.id;

  nodeStore.deleteNodeRef(projectId.value, bpId.value, bpNodeId, childBpNodeId).then(() => {
    closeModal();
  });
}
</script>

<template>
  <ModalTemplateCenter @submit="deleteLink" :disableButtons="deleteNodeRefRequest.isLoading">
    <template v-slot:title>
      Вы уверены, что хотите удалить связь между узлами "{{sourceNodeTitle}}" и "{{targetNodeTitle}}"?
    </template>
    <template v-slot:body>
      <div
        class="d-flex justify-content-center align-items-center"
        v-if="deleteNodeRefRequest.isLoading"
      >
        <img src="@/assets/img/loader.gif" alt="loader">
      </div>
      <p v-if="deleteNodeRefRequest.error" class="error-mesage">
        {{ deleteNodeRefRequest.error }}
      </p>
    </template>
    <template v-slot:submit>Удалить</template>
  </ModalTemplateCenter>
</template>
